export default __webpack_public_path__ + "images/icons/comment-54c20a0b6916ae7865c0b25d1c32fcae.svg";